var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2682_15284)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8 10.9091H12.15V13.4727L14.346 14.7545L13.671 15.9364L10.8 14.2636V10.9091ZM14.4 6.36364H1.8V16.3636H6.003C5.616 15.5364 5.4 14.6091 5.4 13.6364C5.4 11.9486 6.06375 10.33 7.24523 9.13659C8.42671 7.94318 10.0291 7.27273 11.7 7.27273C12.663 7.27273 13.581 7.49091 14.4 7.88182V6.36364ZM1.8 18.1818C1.32261 18.1818 0.864773 17.9903 0.527208 17.6493C0.189642 17.3083 0 16.8458 0 16.3636V3.63636C0 2.62727 0.801 1.81818 1.8 1.81818H2.7V0H4.5V1.81818H11.7V0H13.5V1.81818H14.4C14.8774 1.81818 15.3352 2.00974 15.6728 2.35071C16.0104 2.69169 16.2 3.15415 16.2 3.63636V9.18182C17.316 10.3273 18 11.9 18 13.6364C18 15.3241 17.3363 16.9427 16.1548 18.1361C14.9733 19.3295 13.3709 20 11.7 20C9.981 20 8.424 19.3091 7.29 18.1818H1.8ZM11.7 9.22727C10.5423 9.22727 9.43208 9.6918 8.61348 10.5187C7.79488 11.3455 7.335 12.467 7.335 13.6364C7.335 16.0727 9.288 18.0455 11.7 18.0455C12.2732 18.0455 12.8408 17.9314 13.3704 17.7098C13.9 17.4883 14.3812 17.1635 14.7865 16.7541C15.1919 16.3446 15.5134 15.8586 15.7327 15.3237C15.9521 14.7887 16.065 14.2154 16.065 13.6364C16.065 11.2 14.112 9.22727 11.7 9.22727Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2682_15284"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.2f2548619c5d28c019ad891bc8ec72ce.svg";
export { ForwardRef as ReactComponent };